// Shared admin tab constants
export const COURSE_LABEL = {
  propaganda: 'Propaganda Clássica',
  digital: 'Direito Digital e IA',
  combo: 'Combo Eleições 2026',
};

export const COURSE_VALUE = { propaganda: 999, digital: 2000, combo: 2699 };

export const COURSE_KEYS = ['propaganda', 'digital', 'combo'];

export const BRL = (v) =>
  Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

// Status helpers — replace nested ternaries
export function getVendaStatusLabel(venda) {
  if (venda.status === 'cancelado') return 'Cancelado';
  if (venda.payment_status === 'pago') return 'Pago';
  return 'Pendente';
}

export function getVendaStatusBadgeClass(venda) {
  if (venda.status === 'cancelado') return 'bg-gray-200 text-gray-700 border-0';
  if (venda.payment_status === 'pago') return 'bg-emerald-100 text-emerald-800 border-0';
  return 'bg-amber-100 text-amber-800 border-0';
}

export function getLegacyStatusBadgeClass(status) {
  if (status === 'confirmed') return 'bg-green-100 text-green-800';
  return 'bg-yellow-100 text-yellow-800';
}

export function getLegacyPaymentBadgeClass(payment_status) {
  if (payment_status === 'paid') return 'bg-emerald-100 text-emerald-800';
  return 'bg-orange-100 text-orange-800';
}

export function getComboRemainingClass(remaining) {
  if (remaining <= 10) return 'text-red-600';
  if (remaining <= 25) return 'text-orange-600';
  return 'text-gray-900';
}
